import styled, { css } from 'styled-components'

export const Content = styled.div``

export const FormItemLabelWrapper = styled.div`
    position: relative;
    width: 100%;
    margin-right: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
    gap: 4px;
`

export const FormItemLabel = styled.span<{ required?: boolean }>`
    position: relative;
    ${({ required }) =>
        required &&
        css`
            &::after {
                content: '*';
                position: absolute;
                top: 0;
                right: -12px;
                color: var(--color-red-500);
            }
        `}
`

export const FormItemContent = styled.div`
    flex-shrink: 0;
    width: 180px;
`
